import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * finance moduli veb-marshrutlari.
 * W: /w/finance (umumiy, hamkorlar balansi, to'lovlar, kassa, pul so'rovlari, moliya hisoboti, jurnal, sozlamalar)
 *    /w/fiscal  (sozlamalar, fiskal modullar, cheklar)
 * S: /s/finance (balans, to'lovlar tarkibi, tranzaksiyalar, to'lov so'rash)
 */
export const workRoutes: RouteObject[] = [
  { path: 'finance', ...page(() => import('./pages/OverviewPage')) },
  { path: 'finance/sellers', ...page(() => import('./pages/BalancesPage')) },
  { path: 'finance/payouts', ...page(() => import('./pages/PayoutsPage')) },
  { path: 'finance/cash', ...page(() => import('./pages/CashPage')) },
  { path: 'finance/requests', ...page(() => import('./pages/RequestsPage')) },
  { path: 'finance/report', ...page(() => import('./pages/ReportPage')) },
  { path: 'finance/journal', ...page(() => import('./pages/JournalPage')) },
  { path: 'finance/settings', ...page(() => import('./pages/SettingsPage')) },
  { path: 'fiscal', ...page(() => import('./pages/FiscalSettingsPage')) },
  { path: 'fiscal/modules', ...page(() => import('./pages/FiscalModulesPage')) },
  { path: 'fiscal/receipts', ...page(() => import('./pages/ReceiptsPage')) },
];

export const sellerRoutes: RouteObject[] = [{ path: 'finance', ...page(() => import('./pages/SellerFinancePage')) }];
